module.exports = __webpack_public_path__ + "static/img/login.f22badd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/default/img/login.png
// module id = Xu70
// module chunks = 1